import { render, staticRenderFns } from "./review-detail.vue?vue&type=template&id=ea9a2fd2&scoped=true"
import script from "./review-detail.vue?vue&type=script&lang=js"
export * from "./review-detail.vue?vue&type=script&lang=js"
import style0 from "./review-detail.vue?vue&type=style&index=0&id=ea9a2fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9a2fd2",
  null
  
)

export default component.exports